// src/auth.js

export const users = [
  { username: "admin", password: "admin123", role: "admin", campus: "all" },
  { username: "finance_bulacan", password: "finance123", role: "finance", campus: "bulacan" },
  { username: "finance_gapan", password: "finance123", role: "finance", campus: "gapan" },
  { username: "registrar_bulacan", password: "registrar123", role: "registrar", campus: "bulacan" },
  { username: "registrar_gapan", password: "registrar123", role: "registrar", campus: "gapan" }
];

export function login(username, password) {
  const user = users.find(u => u.username === username && u.password === password);
  if (user) {
    const { username, role, campus } = user;
    localStorage.setItem("user", JSON.stringify({ username, role, campus }));
    return { username, role, campus };
  }
  return null;
}

export function logout() {
  localStorage.removeItem("user");
}

export function getCurrentUser() {
  return JSON.parse(localStorage.getItem("user"));
}

export function hasAccess(requiredCampus) {
  const user = getCurrentUser();
  if (!user) return false;
  if (user.role === "admin") return true;
  return user.campus === requiredCampus;
}
